<template>
<div>
	<div id="content">
		<div class="actions-card">
			<div>
				<div class="row mb-2">
					<b-col>
						<h6>Action:</h6>
					</b-col>
					<b-col>
						<small>ID: {{action.id}}</small>
					</b-col>
				</div>
				<div class="row mb-2">
					<div class="col-md-2">
						CTA:
					</div>
					<b-col>
						<b-form-input class="mb-2" v-model="action.cta"></b-form-input>
					</b-col>
				</div>
				1) <b-button class = "btn-md m-2" v-bind:style="{'background-color': actionType == 'appScreen' ? 'green' : 'grey'} " @click="updateAction('appScreen')">App Screen</b-button>
				<b-button class = "btn-md m-2" v-bind:style="{'background-color': actionType == 'cmsPage' ? 'green' : 'grey'} " @click="updateAction('cmsPage')">CMS Page</b-button>
				<b-button class = "btn-md m-2" v-bind:style="{'background-color': actionType == 'externalURL' ? 'green' : 'grey'} " @click="updateAction('externalURL')">Website URL</b-button>
			</div>
			<div v-if="actionType=='appScreen'">
				<p>2) Choose a well known app screen from the dropdown, or enter it manually in the text box.</p>
				<b-row>
					<b-col>
						Select: <b-form-select class = "mb-2" v-model="action.appScreen" :options="appScreenOptions" ></b-form-select>
					</b-col>
					<b-col>
						Manual: <b-form-input class="mb-2" v-model="action.appScreen"></b-form-input> 
					</b-col>
				</b-row>
				<div v-if="this.action.appScreen != null && this.action.appScreen.includes('Questionnaires') && !this.action.appScreen.includes('InBest')">
					3) Questionnaire Key: <b-form-input class="mb-2"  @update="setQuestionnaire"></b-form-input> 
					4) Number of questions per page: <b-form-input class="mb-2" @update="setQuestionsPerPage" ></b-form-input> 
				</div>
				<div class="mt-5 mb-3" v-bind:style="{'font-weight': 'bold'}">
					Final Action (admin):<p> {{action.appScreen}}</p> 
				</div>
			</div>
			<div v-if="actionType=='cmsPage'">
				2) CMS Page Key: <b-form-input class="mb-2" v-model="action.cmsPage"></b-form-input>
				<div class="mt-5 mb-3" v-bind:style="{'font-weight': 'bold'}">
					Final Action (admin):<p> {{action.cmsPage}}</p> 
				</div>
			</div>
			<div v-if="actionType=='externalURL'"> 
				2) Website URL: <b-form-input class="mb-2" v-model="action.externalURL"></b-form-input>
				<div class="mt-5 mb-3" v-bind:style="{'font-weight': 'bold'}">
					Final Action (admin):<p> {{action.externalURL}}</p> 
				</div>
			</div> 
			<div class="d-flex justify-content-end">
				<div class="col-md-3">
					<b-button  class="rounded-circle px-2" @click="removeActionStep" variant="danger"><b-icon-trash font-scale="1.2"/></b-button>
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script>

export default {
  name: 'AppActionCard',
  props: {
	action: {
		type: Object,
		required: true
	},
  },
  data() {
	return{
		actionType: null,
		appScreenOptions: [ 
			{value: "appscreen/Finance", text : "Finances (no nav bar)"},
			{value: "appscreen/Home/Finance", text : "Finances (with nav bar)"},
			{value: "appscreen/Spending", text : "Spending (no nav bar)"}, 
			{value: "appscreen/Spending/Plan", text : "Spending plan (no nav bar)"}, 
			{value: "appscreen/Spending/TransactionTagging", text : "Transaction tagging"}, 
			{value: "appscreen/Home/Spending", text : "Spending (nav bar)"}, 
			{value: "appscreen/Home/Spending/Plan", text : "Spending plan (nav bar)"}, 
			{value: "appscreen/Home/Plan", text : "Plan your finances (nav bar)"}, 
			{value: "appscreen/Plan", text : "Plan your finances (no nav bar)"}, 
			{value: "appscreen/Plan/[pillar name]", text : "Plan pillar (replace name exactly, spaces ok)"}, 
			{value: "appscreen/Home/Resources/Guide", text : "Guide in resources"}, 
			{value: "appscreen/Home/Resources/Marketplace", text : "Marketplace in resources"}, 
			{value: "appscreen/Home/Resources/Calculators", text : "Caclulators in resources"}, 
			{value: "appscreen/Home/Resources/Calculators/[calculator type]", text : "List of caclulators for type (exact type from calculator tag)"}, 
			{value: "appscreen/Home/Resources/Benefits", text : "Benefits in resources"}, 
			{value: "appscreen/Goals", text : "Savings Goals"}, 
			{value: "appscreen/Questionnaires/InBest", text : "InBest"},
			{value: "appscreen/Questionnaires/", text : "Questionnaire"},
			{value: "appscreen/WellbeingHub", text : "Wellbeing Home"}, 
			{value: "appscreen/WellbeingHub/Stats", text : "Wellbeing Stats"}, 
			{value: "appscreen/WellbeingHub/Resilience", text : "Financial Resilience Page"}, 
			{value: "appscreen/ConnectBankAccount", text : "Connect bank account"},
			{value: "/MortgageDetails", text : "Add Mortgage"}, 
			{value: "appscreen/Finances/Accounts/Debt", text : "Debt accounts"},
			{value: "appscreen/Finances/Accounts/CreditCard", text : "Credit card accounts"},
			{value: "appscreen/Finances/Accounts/Current", text : "Current accounts"},
			{value: "appscreen/Finances/Accounts/BankSavings", text : "Bank savings accounts"},
			{value: "appscreen/Finances/Accounts/Mortgage", text : "Mortgage accounts"},
			{value: "appscreen/Finances/Accounts/Pension", text : "Pension accounts"},
			{value: "appscreen/Finances/Accounts/Investment", text : "Investment accounts"},
			{value: "appscreen/Finances/Accounts/Will", text : "Will accounts"},
			{value: "appscreen/Finances/Accounts/Insurance", text : "Insurance accounts"},
		
		],
	}
  },
  methods: {
	setActionType: function() {
		this.actionType = null;
		if (this.action.appScreen != null && this.action.appScreen != "") {  this.actionType = "appScreen"; }
		if (this.action.cmsPage != null && this.action.cmsPage != "") { this.actionType =  "cmsPage"; }
		if (this.action.externalURL != null && this.action.externalURL != "") { this.actionType = "externalURL"; }
		return this.actionType;
	}, 
	updateAction: function(at) {
		this.actionType = at;
		if (at == "appScreen") {
			this.action.cmsPage = "";
			this.action.externalURL = "";
		}
		if (at == "cmsPage") {
			this.action.appScreen = "";
			this.action.externalURL = "";
		}
		if (at == "externalURL") {
			this.action.cmsPage = "";
			this.action.appScreen = "";
		}
	},
	removeActionStep: function() {
		this.$emit("onDeleteAction");
	}
  },
  mounted: function() {
	this.setActionType();
  }
}
</script>

<style>
	.activeBtn {
	background: rgb(243, 16, 0) !important;
	}
	.actions-card {
		padding: 20px;
		margin-bottom: 10px;
		background-color:aliceblue;
	}
</style>